import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const AuthenticatedRoute: FC = () => {
  const location = useLocation();
  const user = { id: "1", lastName: "Doe" };

  if (!user) return <Navigate to="/" state={{ from: location }} />;

  return <Outlet />;
};
